export { Linkedinlogo2 } from "./Linkedinlogo2";
